export const VEHICLE_ADD_FAILED_REQUEST = "VEHICLE_ADD_FAILED_REQUEST";
export const VEHICLE_ADD_LOADING_REQUEST = "VEHICLE_ADD_LOADING_REQUEST";
export const VEHICLE_ADDED_SUCCESS = "VEHICLE_ADDED_SUCCESS";
export const VEHICLE_ADDED_FAILED = "VEHICLE_ADDED_FAILED";
export const VEHICLE_LIST_FETCH_LOADING_REQUEST =
  "VEHICLE_LIST_FETCH_LOADING_REQUEST";
export const VEHICLE_LIST_FETCH_FAILED_REQUEST =
  "VEHICLE_LIST_FETCH_FAILED_REQUEST";
export const VEHICLE_LIST_FETCH_SUCCESS = "VEHICLE_LIST_FETCH_SUCCESS";
export const VEHICLE_LIST_FETCH_FAILED = "VEHICLE_LIST_FETCH_FAILED";
export const VEHICLE_DETAILS_LOADING_REQUEST =
  "VEHICLE_DETAILS_LOADING_REQUEST";
export const VEHICLE_DETAILS_FETCH_SUCCESS = "VEHICLE_DETAILS_FETCH_SUCCESS";
export const VEHICLE_DETAILS_FETCH_FAILED = "VEHICLE_DETAILS_FETCH_FAILED";
export const VEHICLE_DETAILS_FETCH_FAILED_REQUEST =
  "VEHICLE_DETAILS_FETCH_FAILED_REQUEST";
export const VEHICLE_DETAILS_UPLOAD_IMAGE_REQUEST =
  "VEHICLE_DETAILS_UPLOAD_IMAGE_REQUEST";
export const VEHICLE_DETAILS_UPLOAD_IMAGE_SUCCESS =
  "VEHICLE_DETAILS_UPLOAD_IMAGE_SUCCESS";
export const VEHICLE_DETAILS_UPLOAD_IMAGE_FAILURE =
  "VEHICLE_DETAILS_UPLOAD_IMAGE_REQUEST";
export const VEHICLE_DELETE_LOADING_REQUEST = "VEHICLE_DELETE_LOADING_REQUEST";
export const VEHICLE_DELETE_SUCCESS = "VEHICLE_DELETE_SUCCESS";
export const VEHICLE_DELETE_FAILED = "VEHICLE_DELETE_FAILED";
export const VEHICLE_DELETE_FAILED_REQUEST = "VEHICLE_DELETE_FAILED_REQUEST";
export const EDIT_VEHICLE_DETAILS_REQUEST = "EDIT_VEHICLE_DETAILS_REQUEST";
export const EDIT_VEHICLE_DETAILS_SUCCESS = "EDIT_VEHICLE_DETAILS_SUCCESS";
export const EDIT_VEHICLE_DETAILS_FAILURE = "EDIT_VEHICLE_DETAILS_FAILURE";
export const SET_SELECTED_VEHICLE_DETAILS = "SET_SELECTED_VEHICLE_DETAILS";
